import { getFeaturesPopupDetail, postNeverMind } from "api/settingAPI";
import { useAuth } from "components/Auth";
import useStatusMutation from "hook/useStatusMutation";
import { useMemo, useRef, useState } from "react";
import FeaturesPopup from "./FeaturesPopup";
import {
  FeaturesPopupData,
  FeaturesPopupDetailResponse,
} from "api/interfaces/settingsInterface.interface";
import { useQuery } from "react-query";
import { MdOutlineAutoAwesome } from "react-icons/md";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { onChangeRead } from "redux/reducers/announcement/announcementSlice";

export default function Announcement({
  isShowButton,
}: {
  isShowButton?: boolean;
}) {
  const { user } = useAuth();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { isRead } = useAppSelector((state) => state.announcement);
  const dispatch = useAppDispatch();

  const {
    data: announcementResult,
    isFetching,
    isLoading,
  } = useQuery(
    ["announcement", user.email],
    () => getFeaturesPopupDetail(user.email),
    {
      enabled: !!user.email,
      retry: 0,
      refetchOnWindowFocus: false,
      onSuccess: (res: FeaturesPopupDetailResponse) => {
        if (isShowButton || isRead) {
          dispatch(onChangeRead(true));
          setIsOpen(false);
          return;
        }
        const result: FeaturesPopupData = res.result;
        setIsOpen(!!result?.isLive && !result?.isRead);
      },
    }
  );
  const data = useMemo<FeaturesPopupData | null>(() => {
    if (
      announcementResult?.error === 0 &&
      announcementResult?.result?.isActive
    ) {
      const result: FeaturesPopupData = announcementResult?.result;
      return {
        ...result,
        slides: [...result.slides].sort((a, b) => a.slideOrder - b.slideOrder),
      };
    }
    return null;
  }, [announcementResult]);

  //사용자가 API오류가 나더라도 팝업이 닫혀야함
  const mutationDontShowAgain = useStatusMutation(postNeverMind, {
    onSuccess: () => {},
    onError: () => {},
  });
  const onClosePopup = () => {
    setIsOpen(false);
    dispatch(onChangeRead(true));
  };
  const onClickDontShowAgain = () => {
    if (!mutationDontShowAgain.idle || !data?.id) return;
    onClosePopup();
    mutationDontShowAgain.mutate(data.id);
  };

  if (isLoading || isFetching) return null;
  if (data) {
    return (
      <>
        {isShowButton && (
          <button
            onClick={() => setIsOpen(!isOpen)}
            data-testid="blocks-announcement-blocks-button-set-is-open"
          >
            <MdOutlineAutoAwesome />
            What's New
          </button>
        )}

        {isOpen && (
          <FeaturesPopup
            data={data}
            onModal={onClosePopup}
            onClickDontShowAgain={onClickDontShowAgain}
            isShowAgain={!isShowButton}
          />
        )}
      </>
    );
  }
  return null;
}
